"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VerticalTabs", {
  enumerable: true,
  get: function () {
    return _VerticalTabs.default;
  }
});
var _VerticalTabs = _interopRequireDefault(require("./VerticalTabs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }